import { Link } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";
import { Button } from "../components/ui/button";

export default function NotFound() {
  const { t } = useLanguage();
  return (
    <div data-testid="not-found-page" className="min-h-[70vh] flex flex-col items-center justify-center text-center px-4">
      <h1 className="font-serif text-6xl text-gold mb-4">404</h1>
      <p className="text-white/60 mb-8">Pagina niet gevonden / Page not found</p>
      <Link to="/">
        <Button className="bg-gold text-white hover:bg-gold-hover rounded-none px-8">{t("booking.success.backHome")}</Button>
      </Link>
    </div>
  );
}
